/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetRecruitmentQueryResponse, GetRecruitmentQueryParams, GetRecruitment400 } from '../entities/GetRecruitment'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetRecruitmentUrl() {
  return `/recruitment` as const
}

/**
 * @description Получение вербовок таксопарка
 * @summary Получение вербовок таксопарка
 * {@link /recruitment}
 */
export async function getRecruitment(params: GetRecruitmentQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetRecruitmentQueryResponse, ResponseErrorConfig<GetRecruitment400>, unknown>({
    method: 'GET',
    url: getGetRecruitmentUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}